export const dataThemeAttributeName = 'data-bs-theme';
export const dataDarkThemeAttribute = `[${dataThemeAttributeName}="dark"]`;
